<template>
<div>
  <table>
    <tr><td><Router-Link :to="{ name: 'client', params: {id: client.numero || '000000000'} }">{{ client.nom || "anonymous" }}</Router-Link></td></tr>
    <tr><td>{{ client.numero || "?" }}</td></tr>
    <tr><td>{{ client.rue || "?" }}</td></tr>
    <tr><td>{{ client.ville || "?" }}</td></tr>
    <tr v-if="client.commentaire"><td>{{ client.commentaire }}</td></tr>
  </table>
</div>
</template>
<script>
export default {
       name: 'ticket-client',
       props: {'client': { type: Object, required: true } },
}
</script>
<style>
  table {
      width: 90%;
      font-family: 'monospace';
      font-size: 8pt;
  }
</style>
